"use client";

import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { useRouter } from "next/navigation";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { Form } from "@/components/ui/form";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { cancellationFormSchema } from "@/lib/utils";
import MyCustomFormField, { FormFieldType } from "./MyCustomFormField";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import RatingReview from "./RatingReview";
import { postComplain } from "@/lib/actions/complain.actions";


const ReviewPopover = ({
  booking_id,
  rating,
}: {
  booking_id: string;
  rating:number;
}) => {

  const formSchema = cancellationFormSchema();
  const [isLoading, setIsLoading] = useState(false);
  const [localRating, setLocalRating] = useState(rating);
  const [calendarOpen, setCalendarOpen] = useState(false);
  const router = useRouter();

  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      comment: "",
    },
  });

  const onSubmit = async (data: z.infer<typeof formSchema>) => {
    setIsLoading(true);

    const comment = `[labelleconciergerie] Ticket: ${booking_id} - Note: ${localRating} - Commentaire: ${data.comment} `;

    try {
        const result = await postComplain({comment});
        if (!result || result.error) {
          toast.success(`Une erreur s'est produite`);
        } else{
          toast.success("Votre message a bien été pris enregistré");
        }
      } catch (error) {
        console.error("ComplainForm", error);
      } finally {
        setIsLoading(false);
        router.refresh();
      }   

  };

  return (
    <div className="flex flex-col items-center"> 
      <Popover open={calendarOpen} onOpenChange={setCalendarOpen}>
        <PopoverTrigger asChild>
          <Button variant="outline" className={"view-all-btn"}>
          Commentaire
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-80 bg-white">
          <div className="grid gap-4">
            <div className="space-y-2">
              <h4 className="font-medium leading-none">Commentaire</h4>
            </div>
            <div>
              <Form {...form}>
                <form
                  onSubmit={form.handleSubmit(onSubmit)}
                  className="space-y-4"
                >
                  <RatingReview rating={localRating} setRating={setLocalRating} />

                  <MyCustomFormField
                    fieldType={FormFieldType.TEXTAREA}
                    control={form.control}
                    name="comment"
                    label= ""
                    placeholder={"Commentaire"}
                    maxLength={20}
                  ></MyCustomFormField>
                  
                  <div className="flex flex-col gap-4">
                    <Button
                      type="submit"
                      className="form-btn"
                      disabled={isLoading}
                    >
                      {isLoading ? (
                        <div className="flex">
                          <Loader2 size={20} className="animate-spin" /> &nbsp;
                          En cours...
                        </div>
                      ) : (
                        "Confirmer"
                      )}
                    </Button>
                  </div>
                </form>
              </Form>
            </div>
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
};

export default ReviewPopover;
